import React from 'react';

import { Typography } from '@mui/material';
import LabelCDS from '@sharedCR/coreDesignSystem/LabelCDS';
import { LabelSize } from '@sharedCR/coreDesignSystem/LabelCDS/LabelCDS.constants';

import {
  DRAW_INSPECTION_LABEL,
  DRAW_LIST_COLUMN_KEY,
  DRAW_STATUS_LABEL,
} from '../../Construction.constants';
import { formatMoney } from '../../Construction.utils';

import RowReviewButton from './components/RowReviewButton';

const KEY = DRAW_LIST_COLUMN_KEY;

const renderStatusLabel = (map, value) => {
  const label = map[value];

  if (!label) {
    return null;
  }

  return <LabelCDS size={LabelSize.S} title={label.title} variant={label.variant} />;
};

export const getDrawListConfig = ({ onReview }) => ({
  [KEY.DRAW]: {
    label: 'Draw #',
    align: 'left',
    content: row => <Typography variant="medium14">{row.label}</Typography>,
  },
  [KEY.REQUESTED]: {
    label: 'Requested',
    align: 'right',
    content: row => <Typography variant="regular14">{formatMoney(row.requested)}</Typography>,
  },
  [KEY.APPROVED]: {
    label: 'Approved',
    align: 'right',
    content: row => <Typography variant="regular14">{formatMoney(row.approved)}</Typography>,
  },
  [KEY.STATUS]: {
    label: 'Status',
    align: 'left',
    content: row => renderStatusLabel(DRAW_STATUS_LABEL, row.status),
  },
  [KEY.INSPECTION]: {
    label: 'Inspection',
    align: 'left',
    content: row => renderStatusLabel(DRAW_INSPECTION_LABEL, row.inspectionStatus),
  },
  [KEY.REQUEST_DATE]: {
    label: 'Request Date',
    align: 'left',
    content: row => (
      <Typography color="text.secondary" variant="regular14">
        {row.requestDateLabel}
      </Typography>
    ),
  },
  [KEY.ACTIONS]: {
    label: 'Actions',
    align: 'right',
    content: row => <RowReviewButton drawRequestId={row.id} onReview={onReview} />,
  },
});
